import { jsx as _jsx } from "react/jsx-runtime";
import { GameManagement } from "@/pages/game-management";
var TableRounds = function (_a) {
    var recordData = _a.recordData, t = _a.t;
    console.log(recordData);
    return _jsx(GameManagement, { tableId: recordData.id, tableData: recordData, requestType: "tableId" });
};
export default TableRounds;
